import { qualifyUrls } from 'routing/Routes';
import AppConfig from 'util/AppConfig';

const SymantecSESRoutes = {
  INTEGRATIONS: {
    SymantecSES: {
      ACTIVITYAPI: {
        index: '/integrations/symantecses',
      },
    },
  },
};

const ApiRoutes = {
  INTEGRATIONS: {
    SymantecSES: {
      SAVE_INPUT: '/plugins/org.graylog.enterprise.integrations/symantecses/inputs',
      CHECK_CREDENTIALS: '/plugins/org.graylog.enterprise.integrations/symantecses/checkCredentials',

    },
  },
};

const DocsRoutes = {
  INTEGRATIONS: {
    SymantecSES: {
      GRAYLOG_SymantecSES_ACTIVITY_LOG_INPUT: 'integrations/inputs/graylog_symantecSES_ActivityLog_Input.html#graylog-symantecSES-activitylog-input',
    },
  },
};

const qualifiedRoutes = AppConfig.gl2AppPathPrefix() ? qualifyUrls(SymantecSESRoutes, AppConfig.gl2AppPathPrefix()) : SymantecSESRoutes;

export default {
  ...qualifiedRoutes,
  unqualified: SymantecSESRoutes,
};

export { DocsRoutes, ApiRoutes };
